import { WidgetDescription } from 'controls/designer/features/widgets/types';
import GlobalTimeSelectorWidget from 'controls/designer/features/widgets/globalTimeSelector/widget';
import { GlobalTimePeriodConfig } from 'controls/designer/features/widgets/globalTimeSelector/types';
import { ApplicationState } from 'framework/applicationState';
import Configuration from './configuration';
import { TimePeriodType } from 'controls/react/form/timePeriodType';
import { i18n } from './localization';

export const GlobalTimePeriodWidgetType = 'global-time-selector';
export function getWidgetDescription(): WidgetDescription<GlobalTimePeriodConfig> {
	return {
		form: Configuration,
		defaultConfig: {
			type: GlobalTimePeriodWidgetType,
			title: i18n('Global Timebar'),
			periodEnabled: true,
			timeZoneEnabled: true,
			period: { period: TimePeriodType.Last24Hours },
			timezone: ApplicationState.timezone,
		},
		height: 65,
		width: 430,
		widget: GlobalTimeSelectorWidget,
		fullTitle: i18n('Global Timebar'),
		preProcessConfig: (config: GlobalTimePeriodConfig) => {
			config = JSON.parse(JSON.stringify(config));
			return config;
		},
		containerStyle: {
			header: 'on-hover',
		},
	};
}
